module.exports = __webpack_public_path__ + "img/chivas-agepage-bg.72edfa5c.webp";